// DownloadSection.js
import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import './DownloadSection.css';  // Ensure you have this CSS file for styling
import { CONTENT, DOWNLOAD_LINKS } from '../config/landingPageContent';
import DemoVideoButton from '../demos/DemoVideoButton';

// Wraps the hero's highlight word (e.g. "hired") in a styled span so it pops
// even when line-wrapping pushes it onto its own line.
const renderWithHighlight = (text, word) => {
  if (!word) return text;
  const idx = text.toLowerCase().lastIndexOf(word.toLowerCase());
  if (idx === -1) return text;
  return (
    <>
      {text.slice(0, idx)}
      <span className="hero-highlight">{text.slice(idx, idx + word.length)}</span>
      {text.slice(idx + word.length)}
    </>
  );
};

const DownloadSection = ({ variant = 'default' }) => {
  const [isMobile, setIsMobile] = useState(false);
  const content = CONTENT[variant] || CONTENT.default;

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPhone|iPad|iPod|Android/i.test(userAgent)) {
      setIsMobile(true);
    }
  }, []); // Empty dependency array to run once on component mount

  const handleDownloadClick = () => {
    window.location.href = DOWNLOAD_LINKS.appleSilicon;
  };

  // Convocue is macOS-only, so on phones we open the Messages app with the
  // download link pre-filled — the user texts it to themselves for later.
  const handleTextMeClick = () => {
    const path = variant === 'assistant' ? '/assistant/download' : '/download';
    const link = `${window.location.origin}${path}`;
    const body = encodeURIComponent(`Convocue for Mac — download it here: ${link}`);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    window.location.href = isIOS ? `sms:&body=${body}` : `sms:?body=${body}`;
  };

  return (
    <div className="download-header">
      <h1>{content.hero.title}</h1>
      <p className="hero-subtitle hero-subtitle--desktop">{renderWithHighlight(content.hero.subtitle, content.hero.highlight)}</p>
      <p className="hero-subtitle hero-subtitle--mobile">{renderWithHighlight(content.hero.subtitleShort, content.hero.highlight)}</p>
      <div className="hero-badges">
        {content.hero.badges.map((badge) => (
          <span className="hero-badge" key={badge}>{badge}</span>
        ))}
      </div>
      <div className="download-container">
        {isMobile ? (
          <button className="App-button" onClick={handleTextMeClick}>
            <MessageCircle className="text-me-icon" size={20} />
            Text Me the Mac App
          </button>
        ) : (
          <button className="App-button" onClick={handleDownloadClick}>
            <svg className="download-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
            </svg>
            Download For Apple Silicon
          </button>
        )}
        <DemoVideoButton />
      </div>
      <div className="download-note">
        {isMobile
          ? 'Runs on macOS — text yourself the link.'
          : '* Free trial available - No credit card required'}
      </div>
    </div>
  );
};

export default DownloadSection;
